var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import Col from "antd/es/col";
import "antd/es/col/style/index.js";
import Row from "antd/es/row";
import "antd/es/row/style/index.js";
import { observer } from 'mobx-react';
let AbfragerMultipleChoiceOptionsLayoutButton = class AbfragerMultipleChoiceOptionsLayoutButton extends React.PureComponent {
    render() {
        const { children } = this.props;
        const optionNodes = children;
        const num = optionNodes.length;
        return (React.createElement(Row, { gutter: 16 }, optionNodes.map((optionNode, index) => {
            const style = { display: 'flex', flexDirection: 'row' };
            if (num === 2 && index === 0) {
                style.flexDirection = 'row-reverse';
            }
            return (React.createElement(Col, { span: 24 / optionNodes.length, style: style, key: index }, optionNode));
        })));
    }
};
AbfragerMultipleChoiceOptionsLayoutButton = __decorate([
    observer
], AbfragerMultipleChoiceOptionsLayoutButton);
export { AbfragerMultipleChoiceOptionsLayoutButton };
